import type {
  QuickFixBenefit,
  QuickFixRepairItem,
  QuickFixSpecialtyContractor,
} from './types';

export const QWIKFIX_BENEFITS: QuickFixBenefit[] = [
  {
    icon: '⚡',
    title: '24 Hours or Less',
    sub: 'Quote back in 24 hours, 7 days a week',
  },
  {
    icon: '🛡️',
    title: 'Licensed Contractors',
    sub: 'Vetted pros before or after closing',
  },
];

export const QWIKFIX_PRICING = {
  listPrice: 50,
  promoPrice: 0,
  label: 'rapid quote',
};

export const SAMPLE_QUICKFIX_ITEMS: QuickFixRepairItem[] = [
  {
    id: 'i1',
    title: 'Eaves/Fascia/Soffit Observations',
    section: 'Exterior · §3.1',
    recommendationId: undefined,
    isCategorizedByRepairCompany: false,
    thumbVariant: 't1',
  },
  {
    id: 'i2',
    title: 'Wall Cladding Observations',
    section: 'Exterior · §3.4',
    recommendationId: undefined,
    isCategorizedByRepairCompany: false,
    thumbVariant: 't2',
  },
  {
    id: 'i3',
    title: 'Gas Meter Shutoff Valve — Tagging',
    section: 'Plumbing · §4.2',
    recommendationId: 'plumbing',
    isCategorizedByRepairCompany: true,
    thumbVariant: 't3',
  },
  {
    id: 'i4',
    title: 'Brick Veneer Cracking, SW Corner',
    section: 'Structural · §2.6',
    recommendationId: undefined,
    isCategorizedByRepairCompany: false,
    thumbVariant: 't4',
  },
  {
    id: 'i5',
    title: 'Water Heater TPR Valve Discharge',
    section: 'Plumbing · §4.8',
    recommendationId: 'plumbing',
    isCategorizedByRepairCompany: true,
    thumbVariant: 't3',
  },
  {
    id: 'i6',
    title: 'GFCI Missing — Kitchen Counter Receptacle',
    section: 'Electrical · §5.3',
    recommendationId: 'electrical',
    isCategorizedByRepairCompany: true,
    thumbVariant: 't2',
  },
  {
    id: 'i7',
    title: 'Furnace Combustion Air — Inadequate',
    section: 'HVAC · §6.1',
    recommendationId: 'hvac',
    isCategorizedByRepairCompany: true,
    thumbVariant: 't4',
  },
];

export const SAMPLE_SPECIALTY_CONTRACTORS: QuickFixSpecialtyContractor[] = [
  {
    id: 'plumbpro',
    name: 'PlumbPro Services',
    initials: 'PP',
    color: '#1e3a8a',
    email: 'quotes@plumbpro.com',
    phone: '+1 (480) 555-0142',
    responseTime: '4 hours avg',
    specialties: ['Plumbing', 'Water Heaters', 'Sewer'],
    recommendedIds: ['plumbing'],
  },
  {
    id: 'voltworks',
    name: 'VoltWorks Electric',
    initials: 'VW',
    color: '#7c2d12',
    email: 'service@voltworks.com',
    phone: '+1 (480) 555-0188',
    responseTime: '8 hours avg',
    specialties: ['Electrical', 'Panel Upgrades'],
    recommendedIds: ['electrical'],
  },
  {
    id: 'climateco',
    name: 'ClimateCo HVAC',
    initials: 'CC',
    color: '#065f46',
    email: 'dispatch@climateco.com',
    phone: '+1 (480) 555-0207',
    responseTime: '12 hours avg',
    specialties: ['HVAC', 'Furnace', 'AC'],
    recommendedIds: ['hvac'],
  },
];
